import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher/appDispatcher';
import { get } from 'lodash';
import ActionType from 'constants/actionType';

class AppBannerStore  extends ReduceStore {

  get content() { return get(this.getState(), 'content', null); }

  constructor() {
    super(Dispatcher);
  }

  getInitialState() {
    return {
      content: null
    };
  }

  reduce(state, action) {
    switch (action.actionType) {

      case ActionType.APP_BANNER_SET_CONTENT:
        return {
          ...state,
          content: action.content
        };

      case ActionType.AUTH_LOGOUT:
      case ActionType.AUTH_LOGOUT_ACT_AS:
        return this.getInitialState();

      default:
        return state;
    }
  }

}

export const appBannerStore = new AppBannerStore();
